<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="components-preview wide-md mx-auto">
                    <div class="nk-block-head nk-block-head-lg wide-sm">
                        <div class="nk-block-head-content">
                            <h4 class="nk-block-title fw-normal">Buy New Package</h4>
                        </div>
                    </div>
                    <div class="nk-block nk-block-lg">
                        <div class="card">
                            <div class="card-inner">
                                <div class="preview-block">
                                    <span class="preview-title-lg overline-title">Package Information : {{buyPackagePrice.packagePlanName}} ${{buyPackagePrice.packagePlanAmount}}/</span>
                                    <div class="row gy-4">
                                        <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8">
                                            <div class="row gy-4">
                                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <div class="form-group">
                                                        <label class="form-label" for="default-01">Choose Bank For Payment Depsit</label>
                                                        <div class="g-4 align-center flex-wrap">
                                                            <div class="g" v-for="bank in bankList" :key="bank.id">
                                                                <div class="custom-control custom-radio" v-on:click="SelectBank(bank)">
                                                                    <input v-model="bankId" type="radio" class="custom-control-input" :value="bank.bankName" v-bind:id="bank.id">
                                                                    <label class="custom-control-label" v-bind:for="bank.id">{{bank.bankName}}</label>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <div class="form-group" v-if="bankDetail.bankName=='Voucher'">
                                                        <label class="form-label">Voucher Number</label>
                                                        <input v-model="buyPackagePrice.voucherNo" type="text" @focus="$event.target.select()" class="form-control" />
                                                    </div>


                                                    <div class="form-group" v-if="bankDetail.bankName=='USDT (TRC20)'">
                                                        <label class="form-label">USDT Wallet Detail</label>
                                                        <ul class="pricing-features">
                                                            <li><span class="w-50">USDT Wallet</span> - <span class="ms-auto">{{bankDetail.bankName}}</span></li>
                                                            <li>
                                                                <span class="w-30">USDT Wallet Address</span>
                                                                <span class="ms-auto w-60">
                                                                    <div class="nk-refwg-url">
                                                                        <div class="form-control-wrap">
                                                                            <div class="form-clip clipboard-init" data-clipboard-target="#usdt" data-success="Copied"><em class="clipboard-icon icon ni ni-copy"></em> <span class="clipboard-text"></span></div>
                                                                            <div class="form-icon">
                                                                                <em class="icon ni ni-link-alt"></em>
                                                                            </div>
                                                                            <input type="text" class="form-control copy-text" id="usdt" :value="bankDetail.accountNumber">
                                                                        </div>
                                                                    </div>                                                                    
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="form-group" v-else>
                                                        <label class="form-label">Bank Detail</label>
                                                        <ul class="pricing-features">
                                                            <li><span class="w-50">Bank Name</span> - <span class="ms-auto">{{bankDetail.bankName}}</span></li>
                                                            <li><span class="w-50">Account Title</span> - <span class="ms-auto">{{bankDetail.accountTitle}}</span></li>
                                                            <li><span class="w-50">Account Number</span> - <span class="ms-auto">{{bankDetail.accountNumber}}</span></li>
                                                            <li><span class="w-50">Iban Number</span> - <span class="ms-auto">{{bankDetail.ibanNumber}}</span></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">ScreenShot Attach</label>
                                                <div class="form-control-wrap">
                                                    <uploadimage v-on:picPath="getImage" v-bind:path="buyPackagePrice.screenShotImage" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div class="form-group">
                                                <label class="form-label">Description</label>
                                                <div class="form-control-wrap">
                                                    <textarea v-model="buyPackagePrice.description" class="form-control no-resize"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <hr class="preview-hr">
                                    <div class="row gy-4 ">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                                            <button v-bind:disabled="$v.$invalid" v-on:click="SaveNewUser()" class="btn btn-primary" style="margin-right: 10px;"> Save</button>
                                            <a href="javascript:void(0)" v-on:click="GoToList()" class="btn btn-danger"> Cancel</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators';
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default ({
        components: {
            Loading
        },
        name: 'Deposit',
        data: function () {
            return {
                loading: false,

                bankList: [],
                bankDetail: [],
                bankId: [],
                buyPackagePrice: {
                    id: '00000000-0000-0000-0000-000000000000',
                    packagePlanName: '',
                    packagePlanAmount: '',
                    screenShotImage: '',
                    packagePriceId: '',
                    description: '',
                    bankId: '',
                    userId: '',
                    voucherNo: '',
                    approval: 'Processing',
                    isNewId: false,
                }
            }
        },
        validations: {
            buyPackagePrice:
            {
                packagePlanAmount:
                {
                    required
                },
                packagePriceId:
                {
                    required
                },
                bankId:
                {
                    required
                },
                screenShotImage:
                {
                    required
                }
            }
        },

        methods: {
            SelectBank: function (bank) {
                this.bankDetail = bank;
                this.buyPackagePrice.bankId = bank.id;
                this.buyPackagePrice.bankName = bank.bankName;
            },

            getImage: function (path) {

                this.buyPackagePrice.screenShotImage = path;
            },

            GoToList: function () {
                this.$router.push('/PackagePlan');
            },

            SaveNewUser: function () {
                var root = this;
                this.loading = true;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.buyPackagePrice.userId = localStorage.getItem('UserID');

                root.$https.post('/PackagePlan/SaveBuyPackage', this.buyPackagePrice, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {
                            root.loading = false;
                            root.$swal({
                                title: 'Created!',
                                text: 'Data has been Saved successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    if (root.buyPackagePrice.isNewId) {
                                        root.$router.push('/CreateNewId');
                                    }
                                    else {
                                        root.GoToList();
                                    }

                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Warning!',
                                text: response.data.isAddUpdate,
                                type: 'warning',
                                icon: 'warning',
                                confirmButtonClass: "btn btn-warning",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

            GetBankList: function () {
                var root = this;
                var url = '/Company/BankList?isDropDown=true';
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.bankList = response.data.results;
                        root.loading = false;
                    }
                }).catch(error => {

                    console.log(error);
                    root.loading = false;
                    root.$swal.fire({
                        icon: 'error',
                        type: 'error',
                        title: 'Error',
                        text: "Something Went Wrong",
                        showConfirmButton: false,
                        timer: 5000,
                        timerProgressBar: true,
                    });
                }).finally(() => root.loading = false);
            },

        },
        created: function () {


            if (this.$route.query.data != undefined) {
                var packagePrice = this.$route.query.data;

                if (this.$route.query.isNewId == 'true') {
                    this.loading = true;
                    this.GetBankList();

                    this.buyPackagePrice.packagePlanName = packagePrice.name;
                    this.buyPackagePrice.packagePlanAmount = packagePrice.amount;
                    this.buyPackagePrice.packagePriceId = packagePrice.id;
                    this.buyPackagePrice.isNewId = true;
                }
                else {
                    this.loading = true;
                    this.GetBankList();

                    this.buyPackagePrice.packagePlanName = packagePrice.name;
                    this.buyPackagePrice.packagePlanAmount = packagePrice.amount;
                    this.buyPackagePrice.packagePriceId = packagePrice.id;
                    this.buyPackagePrice.isNewId = false;
                }
            }
        },
    })
</script>
